import border, { borderVariants, BorderVariantsType } from './border';
import brand, { brandVariants, BrandVariantsType } from './brand';
import children, { childrenVariants, ChildrenVariantsType } from './children';
import collapseAt, { collapseAtVariants, CollapseAtVariantsType } from './collapse-at';
import container, { containerVariants, ContainerVariantsType } from './container';
import dropdownContainer, { dropdownContainerVariants, DropdownContainerVariantsType } from './dropdown-container';
import innerContainer, { innerContainerVariants, InnerContainerVariantsType } from './inner-container';
import item, { itemVariants, ItemVariantsType } from './item';
import toggle, { toggleVariants, ToggleVariantsType } from './toggle';
import wrapper, { wrapperVariants, WrapperVariantsType } from './wrapper';

export const navbarVariants = {
  border: borderVariants,
  brand: brandVariants,
  children: childrenVariants,
  collapseAt: collapseAtVariants,
  container: containerVariants,
  dropdownContainer: dropdownContainerVariants,
  innerContainer: innerContainerVariants,
  item: itemVariants,
  toggle: toggleVariants,
  wrapper: wrapperVariants
};

const navbar = {
  ...collapseAt,
  border,
  brand,
  children,
  container,
  dropdownContainer,
  innerContainer,
  item,
  toggle,
  wrapper
};

export type NavbarVariantsType = 'border'
| 'brand'
| 'children'
| 'collapseAt'
| 'container'
| 'dropdownContainer'
| 'innerContainer'
| 'item'
| 'toggle'
| 'wrapper';

export interface NavbarType {
  /** The Navbar subcomponent types. */
  Components: NavbarVariantsType;
  /** The Navbar.Border component types. */
  Border: BorderVariantsType;
  /** The Navbar.Brand component types. */
  Brand: BrandVariantsType;
  /** The Navbar.Children component types. */
  Children: ChildrenVariantsType;
  /** The Navbar.CollapseAt component types. */
  CollapseAt: CollapseAtVariantsType;
  /** The Navbar.Container component types. */
  Container: ContainerVariantsType;
  /** The Navbar.DropdownContainer component types. */
  DropdownContainer: DropdownContainerVariantsType;
  /** The Navbar.InnerContainer component types. */
  InnerContainer: InnerContainerVariantsType;
  /** The Navbar.Item component types. */
  Item: ItemVariantsType;
  /** The Navbar.Toggle component types. */
  Toggle: ToggleVariantsType;
  /** The Navbar.Wrapper component types. */
  Wrapper: WrapperVariantsType;
}

export default navbar;
